import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcArrowleftFillNomargin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "12",
    fill: "none",
    viewBox: "0 0 8 12",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 11.45c0 .46-.539.716-.903.429L.21 6.429a.546.546 0 0 1 0-.858L7.097.121C7.461-.166 8 .09 8 .551z"
  }));
}
var IcArrowleftFillNomargin = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowleftFillNomargin));

export { IcArrowleftFillNomargin as I };
